import { Component, Input } from "@angular/core";

@Component({
  selector: "app-search-button",
  template: `
    <button
      class="search-button"
      nbPopover="Hover Mode"
      nbPopoverTrigger="hint"
      nbPopoverPlacement="bottom"
    >
      <i class="nb-search"></i>
    </button>
  `,
  styles: [``],
})
export class SearchButtonComponent {
  @Input() title: string;
}
